"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ControlBase = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = require("@fluentui/react");

var React = _interopRequireWildcard(require("react"));

var _useTheme = require("../hooks/useTheme");

var getClassNames = (0, _react.classNamesFunction)();

var ControlBase = function ControlBase(_ref2) {
  var _ref = _ref2.ref,
      _ref2$tagName = _ref2.tagName,
      tagName = _ref2$tagName === void 0 ? 'div' : _ref2$tagName,
      styles = _ref2.styles,
      _theme = _ref2.theme,
      _ref2$inline = _ref2.inline,
      inline = _ref2$inline === void 0 ? false : _ref2$inline,
      _ref2$outlineInset = _ref2.outlineInset,
      outlineInset = _ref2$outlineInset === void 0 ? 0 : _ref2$outlineInset,
      outlineColor = _ref2.outlineColor,
      onClick = _ref2.onClick,
      _onKeyDown = _ref2.onKeyDown,
      _onMouseDown = _ref2.onMouseDown,
      _onMouseUp = _ref2.onMouseUp,
      _onBlur = _ref2.onBlur,
      className = _ref2.className,
      _ref2$role = _ref2.role,
      role = _ref2$role === void 0 ? 'button' : _ref2$role,
      _ref2$tabIndex = _ref2.tabIndex,
      tabIndex = _ref2$tabIndex === void 0 ? 0 : _ref2$tabIndex,
      children = _ref2.children,
      props = (0, _objectWithoutProperties2.default)(_ref2, ["ref", "tagName", "styles", "theme", "inline", "outlineInset", "outlineColor", "onClick", "onKeyDown", "onMouseDown", "onMouseUp", "onBlur", "className", "role", "tabIndex", "children"]);

  var _useState = (0, React.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isClicked = _useState2[0],
      setIsClicked = _useState2[1];

  var theme = (0, _useTheme.useTheme)();
  var classes = getClassNames(styles, {
    theme: _theme || theme,
    inline: inline,
    showFocus: !isClicked,
    clickable: !!onClick,
    outlineInset: outlineInset,
    outlineColor: outlineColor
  });
  var ref = (0, React.useRef)(null);
  var setRef = (0, React.useCallback)(function (el) {
    if (typeof _ref === 'function') {
      _ref(el);
    } else if (_ref) {
      _ref.current = el;
    }

    ref.current = el;
  }, [_ref]);
  var mouseDown = (0, React.useRef)(false);
  var onMouseDown = (0, React.useCallback)(function (event) {
    mouseDown.current = true;
    setIsClicked(true);

    if (_onMouseDown) {
      _onMouseDown(event);
    }
  }, [setIsClicked, _onMouseDown]);
  var onMouseUp = (0, React.useCallback)(function (event) {
    mouseDown.current = false;

    if (_onMouseUp) {
      _onMouseUp(event);
    }
  }, [_onMouseUp]);
  var onBlur = (0, React.useCallback)(function (event) {
    if (document.activeElement !== event.target) {
      setIsClicked(false);
    }

    if (_onBlur) {
      _onBlur(event);
    }
  }, [setIsClicked, _onBlur]);
  var onKeyDown = (0, React.useCallback)(function (event) {
    if (_onKeyDown) {
      _onKeyDown(event);
    }

    if (!event.isDefaultPrevented() && onClick && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey && (event.key === ' ' || event.key === 'Enter')) {
      onClick(event);
      event.preventDefault();
    }
  }, [onClick, _onKeyDown]);
  (0, React.useEffect)(function () {
    var onWindowFocus = function onWindowFocus() {
      if (document.activeElement !== ref.current) {
        setIsClicked(false);
      }
    };

    window.addEventListener('focus', onWindowFocus, true);
    return function () {
      return window.removeEventListener('focus', onWindowFocus, true);
    };
  }, [setIsClicked]);
  return /*#__PURE__*/React.createElement(tagName, (0, _objectSpread2.default)({
    className: (0, _react.css)(className, 'ms-Control', classes.root),
    tabIndex: tabIndex,
    role: role,
    onClick: onClick,
    onKeyDown: onKeyDown,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    onBlur: onBlur,
    ref: setRef
  }, props), children);
};

exports.ControlBase = ControlBase;